module.exports = __webpack_public_path__ + "static/media/08_avatar_animal.d36c9ac4.png";